import React from 'react';

import GlobalStyle from './globalStyle';

import Home from './pages/Home';

function App() {
  return (
    <>
      <GlobalStyle />
      <Home />
    </>
  );
}

export default App;
